import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import JustValidate from 'just-validate';
import CsfFournisseurRecognitionRenewalTitle
  from "../includes/csf-fournisseur-recognition-renewal-title";

export function FournisseurRecognitionRequestStepPaymentBlock({ hasPreviousRenewalEndDate, company, user, currentStep, onStepChange, accessToken, apiUrl, apiEnv, form, monerisHostUrl, monerisHostId, OnSubmitPaymentForm, isErrorMoneris }) {

  const [validator, setValidator] = useState(null);
  const language = document.documentElement.lang;
  const urlParams = new URLSearchParams(window.location.search);
  const isRenewal = (urlParams.get('renewal') === 'true' || hasPreviousRenewalEndDate);
  const responsibleEmail= company?.Contact__Secondary[0].RREG_Corres_Email_Id__Rn_Descriptor.split(" ")[0];


  useEffect(() => {
    const validator = new JustValidate('#form-stepPayment');
    validator
      .addField('#email', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
        {
          rule: 'email',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.email'),
        },
      ])
      .addField('#signature', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
      ]);
    setValidator(validator);

    return () => validator.destroy();
  }, []);

  const submitPaymentForm = (event) => {
    event.preventDefault();

    if (validator) {
      validator.validate();
      setTimeout(() => {
        if (validator?.isValid) {
          console.log("%c Payment step successful", 'background: #5E5E5E; color: #0f0');
          OnSubmitPaymentForm();
        } else {
          console.error('Form validation failed!');
        }
      });
    }
  };

  function handlePreviousStepClick() {
    onStepChange(currentStep - 1); // Call the callback function with new count
  }

  /**
   * Formate un nombre avec deux décimales et adapte le séparateur décimal
   * en fonction de la langue de la page (virgule pour "fr", point sinon).
   * Le nombre fournit à formatter peut être une string au format "1,234.78",
   * ou une string telle que "123.44", ou "1 234.55", ou "199,67",
   * ou un nombre,
   * et ce format texte n'est pas lié à la langue de la page.
   *
   * @param {number|string} number - Nombre à formater.
   * @returns {string} Nombre formaté en chaîne.
   */
  function formatNumber(number) {
    if (number === null || number === undefined) {
      return 'NaN';
    }

    let str = String(number).trim();

    // Retirer les espaces et apostrophes souvent utilisés comme séparateurs de milliers
    str = str.replace(/[\s']/g, '');

    // Détection des séparateurs décimaux
    const hasComma = str.includes(',');
    const hasDot = str.includes('.');

    if (hasComma && hasDot) {
      // Si les deux sont présents, on suppose que le séparateur de milliers est la virgule
      // et le séparateur décimal est le point
      str = str.replace(/,/g, '');
    } else if (hasComma && !hasDot) {
      // Virgule seule : virgule décimale, on remplace la virgule par un point
      str = str.replace(/,/g, '.');
    }
    // Sinon, point seul ou aucun, on garde tel quel

    const num = Number(str);
    if (isNaN(num)) {
      return 'NaN';
    }

    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', options);

    return formatter.format(num);
  }

  return (
    <main className="fournisseur recognition">

      <h1 id="stepPayment">{window.Drupal.t('fournisseur.creation_form.form.payment.title')}</h1>

      <CsfFournisseurRecognitionRenewalTitle
        isRenewal={isRenewal}
        formData={form} />

      <div className="content">

        <div className="form-steps-content">
          <form id="form-stepPayment" autoComplete="off" noValidate="novalidate" onSubmit={submitPaymentForm}>
            <fieldset>
              <legend className="visually-hidden">{window.Drupal.t('fournisseur.creation_form.form.payment.title')}</legend>

              <div className="payment">

                {language === 'fr' ?
                  (<p>J'autorise la Chambre de la sécurité financière à porter au compte de la carte de crédit indiquée ci-dessous, le montant de {formatNumber(form.Montant_Total)} $ représentant les frais exigibles ({ form.Taxless_Amount !== null ? formatNumber(form.Taxless_Amount) : "00,00"} $ + taxes applicables de {form.TaxAmount !== null ? formatNumber(form.TaxAmount): "00,00"} $).</p>) :
                  (<p>I authorize the CSF to charge the amount of ${formatNumber(form.Montant_Total)} to the account of the credit card provided below, representing the applicable fees (${form.Taxless_Amount !== null ? formatNumber(form.Taxless_Amount) : "00.00"} + applicable taxes of ${form.TaxAmount !== null ? formatNumber(form.TaxAmount): "00,00"}).</p>)}


                <div className="row">
                  <div className="col-12 col-md-6 px-1">
                    <div className="form-group">
                      <label htmlFor="company">{window.Drupal.t('fournisseur.creation_form.form.payment.fields.company')}</label>
                      <input value={user.Primary_Company__Rn_Descriptor} disabled type="text" id="company" />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 px-1">
                    <div className="form-group">
                      <label htmlFor="email">{window.Drupal.t('fournisseur.gestion.table.email.responsable')}*</label>
                      <input defaultValue={responsibleEmail} disabled type="text" id="email"/>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* Voir https://developer.moneris.com/Documentation/NA/E-Commerce%20Solutions/Hosted%20Solutions/Hosted%20Tokenization pour plus de détail sur le iframe et parametre*/}
                  <iframe width="100%" id="monerisFournisseurFrame" title="moneris"
                    src={`${monerisHostUrl}/HPPtoken/index.php?id=${monerisHostId}&pmmsg=true&pan_label=${window.Drupal.t("Card Number")}&exp_label=${window.Drupal.t("Expiration Date (MMYY)")}&cvd_label=${window.Drupal.t("CVD")}&enable_exp=1&enable_cvd=1&enable_exp_formatting=1&enable_cc_formatting=1&display_labels=2&
                          css_body=padding:0 8px;display: flex;flex-wrap:wrap; gap: 16px;&css_textbox=padding:10px;background-color:rgb(233,238,240);border-radius:4px 4px 0 0;border-color: transparent;border-bottom: 1px solid rgb(31,82,105); margin-bottom:10px;height: 47px;width: calc(44% - (16px * 2 / 3));font-family: 'Montserrat-Regular', Arial, sans-serif;&css_textbox_cvd=width: calc(12% - (16px * 2 / 3));"`}
                    frameBorder="0">
                  </iframe>

                </div>

                <p>{window.Drupal.t('fournisseur.creation_form.form.payment.taxes')}<br />
                  {window.Drupal.t('fournisseur.creation_form.form.payment.noaccess')}</p>

                <div className="form-group d-flex align-items-center" style={{ margin: "2rem 0 0", flexWrap: "wrap" }}>
                  <input required type="checkbox" id="signature" name="signature" style={{ flex: "0 1 2.3rem" }} />
                  <label htmlFor="signature" style={{ flex: 1 }}>{window.Drupal.t('fournisseur.creation_form.form.payment.signature')}</label>
                </div>

                {isErrorMoneris === true && (
                  <div className="alert alert-danger" role="alert"
                    aria-live="polite">{window.Drupal.t('broker.manager.error.message')}</div>
                )}

                <div className="payment-notice">
                  <h3>{window.Drupal.t('fournisseur.creation_form.form.payment.text.notice_title')}</h3>
                  <div>{window.Drupal.t('fournisseur.creation_form.form.payment.text.notice_details')}</div>
                </div>

                <div className="payment-service">
                  <img src="/themes/custom/tink/dist/assets/logo-moneris.svg" alt="" />
                  <p>{window.Drupal.t('fournisseur.creation_form.form.payment.text.moneris')}</p>
                </div>

                <div className="row action-buttons">
                  <div className="col text-center">
                    <button className="button btn-outlined btn-larger" type="button" onClick={() => handlePreviousStepClick()}>
                      {window.Drupal.t('fournisseur.previous.btn')}
                    </button>
                  </div>
                  <div className="col text-center">
                    <button className="button btn-larger" type="submit">
                      {window.Drupal.t('fournisseur.creation_form.form.pay')}
                    </button>
                  </div>
                </div>

              </div>

            </fieldset>
          </form>

        </div>
      </div>

    </main >
  );
}

FournisseurRecognitionRequestStepPaymentBlock.propTypes = {
  company: PropTypes.array.isRequired,
  user: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func,
  accessToken: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  monerisHostUrl: PropTypes.string.isRequired,
  monerisHostId: PropTypes.string.isRequired,
  OnSubmitPaymentForm: PropTypes.func.isRequired,
  isErrorMoneris: PropTypes.bool.isRequired,
}
